import axiosInstance from '@/ajax';

const request = config => axiosInstance(config).then(res => res.data.data);

/**
 * 提交自标定任务
 * @param data
 * @returns {*}
 */
export const createCustomPcr = data => request({
  url: '/pipeline/pcr/param',
  method: 'post',
  data,
  params: {
    secret: 'U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
  },
});

/**
 * 获取自标定列表
 * @param params
 * @returns {*}
 */
export const getPcrCustomList = params => request({
  url: '/admin/pcr/list_param',
  params,
});

/**
 * 获取自标定数据详情
 * @param id
 * @returns {AxiosPromise}
 */
export const getPcrCustomDetail = id => request({
  url: '/admin/pcr/get_param',
  params: { pcr_param_id: id },
});

/**
 * pcr自标定数据审核
 * @param data
 * @returns {AxiosPromise}
 */
export const checkPcrCustom = data => request({
  url: '/admin/pcr/pcr_param_check',
  data,
  method: 'post',
});

/**
 * 提交pcr任务
 * @param data
 * @returns {AxiosPromise}
 */
export const createPcrTask = data => request({
  url: '/pipeline/pcr/submit',
  method: 'post',
  data,
  params: {
    secret: 'U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
  },
});

/**
 * 获取pcr任务列表
 * @param params
 * @returns {AxiosPromise}
 */
export const getPcrTaskList = params => request({
  url: '/admin/pcr/list',
  params,
});

/**
 * 获取pcr任务详情
 * @param id
 * @returns {AxiosPromise}
 */
export const getPcrTaskDetail = id => request({
  url: '/admin/pcr/get',
  params: { pcr_task_id: id },
});

/**
 * 审核PCR任务
 * @param data
 * @returns {AxiosPromise}
 */
export const checkPcrTask = data => request({
  url: '/admin/pcr/check',
  data,
  method: 'post',
});


/**
 * 获取PCR TEXTURE 列表
 * @param data
 * @returns {AxiosPromise}
 */
export const getPcrTextureList = params => request({
  url: '/admin/pcr/texture-list',
  params,
  method: 'get',
});

/**
 * 提交PCR TEXTURE 任务
 * @param {*} data
 * @returns
 */
export function createPcrTexture(data) {
  return request({
    url: '/pipeline/pcr/texture-create',
    data,
    method: 'post',
  });
}

/**
 * 提交PCR TEXTURE PIECE 任务
 * @param {*} data
 * @returns
 */
export function createPcrTexturePiece(data) {
  return request({
    url: '/pipeline/pcr/texture-piece-create',
    data,
    method: 'post',
  });
}

/**
 * 提交PCR TEXTURE PIECE 任务
 * @param {*} data
 * @returns
 */
export function createPcrTexturePieceList(data) {
  return request({
    url: '/admin/pcr/texture-piece-list',
    params: data,
    method: 'get',
  });
}
